import React, { useState } from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import "./index.scss"
import { Link } from "gatsby"
import FeatureCard from "../Cards/FeatureCard"

export default function ContentHero({ component }) {
  const { background, featuredContent } = component
  const { article, boxAlignment, textBorderColor } = component.featuredContent[0]
  const { featuredImage, introText, slug, thematicTags, title } = article

  const featuredCardData = {
    button: [
      {
        linkUrl: slug,
        label: 'Read More' 
      }
    ],
    videoLink: '',
    videoSource: '',
    hasVideo: false,
    headline: title,
    intro: introText,
    featureTag: thematicTags[0],
    boxAlignment: boxAlignment,
    featuredImage: [{featuredImage: featuredImage}],
    textBorderColor: textBorderColor,
  }

  return (
    <>
      <div
        data-datocms-noindex
        className="featured-content-hero"
        style={{
          backgroundColor: `${
            background[0].backgroundColor && background[0].backgroundColor
          }`,
        }}
      >
        {background[0].hasBackgroundImage && (
          <GatsbyImage
            image={getImage(background[0].image)}
            className="bg-image"
            alt=""
          />
        )}
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="oblique text-white">Updates</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-md-10">
              <div className="feature-card-wrapper">
                <Link to={`./updates/${slug}`}>
                  <FeatureCard
                    featureData={featuredCardData}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
